export enum TaskField {
  Title = 'title',
  Description = 'description',
  PriorityLevel = 'priorityLevel',
  Category = 'category',
  Status = 'status',
  ReferenceLink = 'referenceLink',
  ReferenceName = 'referenceName',
  CronInterval = 'cronInterval',
  IsCompleted = 'completed',
  Deadline = 'deadline',
  TimeToCompleteAmount = 'timeToCompleteAmount',
  TimeToCompleteType = 'timeToCompleteType',
  Organization = 'organizationId',
  Vendor = 'vendorId',
  Ticket = 'ticketId',
  Assignee = 'assignee',
  CreatedBy = 'createdBy',
  Tag = 'tags',
  Contact = 'contact',
  SubAuditId = 'subauditId',
  EstimatedTime = 'estimatedTime',
  RecurrenceData = 'recurrenceData',
  RecurrenceInterval = 'recurrenceInterval',
  IsNextStep = 'isNextStep',
}
